export interface NamedEntityOutput {
  id: number;
  name: string;
  pluralName?: string;
}

export function namedEntityOutputName(
  entity: NamedEntityOutput,
  resultCount: number | boolean
): string {
  if (resultCount === true || Number(resultCount) > 1) {
    return entity.pluralName || entity.name;
  }
  return entity.name;
}
